module.exports = __webpack_public_path__ + "static/media/c13c-connect.fe394015.png";